import * as ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import * as serviceWorker from './serviceWorker'
import { BrowserRouter } from 'react-router-dom'
import Providers from './Providers'
import Routers from './routers'
import Layout from './Layout'
import { AppContextProvider } from './hooks/AppContextProvider'
import { ViewTenantProvider } from './contexts/ViewTenantContext'
import './i18n'

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')
const root = ReactDOM.createRoot(container)

root.render(
  <BrowserRouter>
    <Providers>
      <AppContextProvider>
        <ViewTenantProvider>
          <Layout renderRouter={Routers} />
        </ViewTenantProvider>
      </AppContextProvider>
    </Providers>
  </BrowserRouter>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
